import Swiper from 'swiper/bundle';
import { Navigation } from 'swiper';

export default ($) => {
    // Homepage swiper
    (() => {
        let swiper = new Swiper('.js-homeSwiper', {
            modules: [Navigation],
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            effect: 'fade',
            speed: 500,
            fadeEffect: {
                crossFade: true
            },
            autoplay: {
                delay: 10000,
            },
        });
    })();

    // Quote swiper
    (() => {
        let swiper = new Swiper('.js-quotesSlider', {
            modules: [Navigation],
            autoHeight: true,
            slidesPerView: 1,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            speed: 500,
        });
    })();

    // Spotlight swiper
    (() => {

        let swiper = new Swiper('.js-spotlightSwiper', {
            modules: [Navigation],
            slidesPerView: "auto",
            spaceBetween: 16,
            speed: 500,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    })();
}